import { CloseOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getBoxPostType, getPersons } from 'app/entities/common/common.reducer';
import { filterOption } from 'app/shared/util/select-filter';
import { isArray } from 'lodash';
import React, { useEffect, useState } from 'react';
import { createEntity, getEntity, updateEntity } from '../organization.reducer';
import * as _ from 'lodash';

type IOrganizationProps = {
  isOpen: boolean;
  id?: string;
  parent?: any;
  isSameOrg: boolean;
  onCancel: () => void;
};

const OrganizationUpdate = ({ isOpen, id, parent, isSameOrg, onCancel }: IOrganizationProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const isNew = id === undefined || id === null;

  const personList = useAppSelector(state => state.common.persons);
  const postTypeList = useAppSelector(state => state.common.postType);
  const organizationEntity = useAppSelector(state => state.organization.entity);
  const updating = useAppSelector(state => state.organization.updating);
  const updateSuccess = useAppSelector(state => state.organization.updateSuccess);
  const [isCheckAccountable, setCheckAccountable] = useState([]);
  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const innitData = () => {
    if (isOpen) {
      // get detail
      dispatch(getBoxPostType({}));
      dispatch(getPersons({}));
      if (isNew) {
        form.resetFields();
      } else {
        dispatch(getEntity(id));
      }
    }
  };

  useEffect(() => {
    if (organizationEntity && !isNew) {
      if (organizationEntity.orgPosts) {
        if (_.some(organizationEntity.orgPosts, (o) => {
          return o.isAccountable
        })) {
          const index = _.findIndex(organizationEntity.orgPosts, (o: any) => {
            return o.isAccountable
          })
          const array = []
          array[index] = true;
          setCheckAccountable(array)
        }
      }
      form.setFieldsValue({
        ...organizationEntity,
      });
    }
  }, [organizationEntity]);

  useEffect(() => {
    innitData();
  }, [isOpen]);

  const handleSubmit = values => {
    const parentAdministrativeId = isNew ? (parent ? parent.id : null) : organizationEntity.parentAdministrativeId;
    const entity = {
      ...organizationEntity,
      ...values,
      orgPosts: values.orgPosts.map((y, index) => {
        return {
          ...y,
          personIds: isCheckAccountable[index] ? (isArray(y.personIds) ? [y.personIds[0]] : [y.personIds]) : y.personIds,
        };
      }),
      parentAdministrativeId,
    };
    if (isNew) {
      (entity.isSameOrganization = isSameOrg), dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleClose = () => {
    form.resetFields();
    onCancel();
  };

  const handleCheckAccountable = (value, index) => {
    const array = [];
    if (value) array[index] = value;
    setCheckAccountable(array);
  };

  return (
    <Modal
      width={800}
      className="modal-filter-custom"
      open={isOpen}
      maskClosable={false}
      footer={null}
      title={`${isNew ? 'Thêm mới' : 'Cập nhật thông tin'} tổ chức`}
      onCancel={handleClose}
    >
      <Form
        size="large"
        initialValues={{
          orgPosts: [
            {
              isManager: false,
              isAccountable: false,
            },
          ],
        }}
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
      >
        <Row>
          <Col md={24}>
            <Form.Item label="Đơn vị cấp trên">
              <Input className="w-100" size="large" disabled value={organizationEntity?.parentName ?? parent?.orgName} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Tên tổ chức" rules={[{ required: true, message: 'Hãy nhập tên tổ chức' }]} name="orgName">
              <Input className="w-100" size="large" placeholder="Nhập tên tổ chức" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Tên viết tắt" name="code">
              <Input className="w-100" size="large" placeholder="Nhập tên viết tắt" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Nhân sự phụ trách kế hoạch" name="pic">
              <Select
                size="large"
                filterOption={filterOption}
                allowClear
                showSearch
                options={personList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn nhân sự phụ trách kế hoạch"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={24}>
            <Form.List name="orgPosts">
              {(fields, { add, remove }) => (
                <div style={{ display: 'flex', rowGap: 16, flexDirection: 'column' }}>
                  {fields.map((field, index) => {
                    return (
                      <Card
                        size="small"
                        title={`Vị trí`}
                        key={field.key}
                        extra={
                          <CloseOutlined
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        }
                      >
                        <Row>
                          <Col md={11}>
                            <Form.Item
                              label="Tên vị trí"
                              rules={[{ required: true, message: 'Hãy nhập tên vị trí' }]}
                              name={[field.name, 'postName']}
                            >
                              <Input size="large" placeholder="Nhập tên vị trí" className="w-100" />
                            </Form.Item>
                          </Col>
                          <Col md={1} />
                          <Col md={12}>
                            <Form.Item label="Nhóm chức danh" name={[field.name, 'postType']}>
                              <Select
                                size="large"
                                filterOption={filterOption}
                                allowClear
                                showSearch
                                options={postTypeList.map(x => {
                                  return {
                                    label: x.name,
                                    value: x.value,
                                  };
                                })}
                                placeholder="Chọn chức danh"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={5}>
                            <Form.Item valuePropName="checked" name={[field.name, 'isManager']}>
                              <Checkbox>Quản lý đơn vị</Checkbox>
                            </Form.Item>
                          </Col>
                          <Col md={1} />
                          {(isCheckAccountable.length <= 0 || isCheckAccountable[index]) ?
                            <Col md={4}>
                              <Form.Item valuePropName="checked" name={[field.name, 'isAccountable']}>
                                <Checkbox
                                  onChange={e => {
                                    handleCheckAccountable(e.target.checked, index);
                                  }}
                                >
                                  Phụ trách
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            : undefined}
                        </Row>
                        <Row>
                          <Col md={24}>
                            <Form.Item label="Nhân sự" name={[field.name, 'personIds']}>
                              <Select
                                mode={isCheckAccountable[index] ? undefined : 'multiple'}
                                size="large"
                                filterOption={filterOption}
                                allowClear
                                showSearch
                                options={personList.map(x => {
                                  return {
                                    label: x.name,
                                    value: x.id,
                                  };
                                })}
                                placeholder="Chọn nhân sự"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    );
                  })}

                  <Button
                    type="dashed"
                    onClick={() =>
                      add({
                        isManager: false,
                        isAccountable: false,
                      })
                    }
                    block
                  >
                    + Thêm vị trí
                  </Button>
                </div>
              )}
            </Form.List>
          </Col>
        </Row>
        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={updating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OrganizationUpdate;
